import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
import Embed from 'v-video-embed'
import { esBloqueoCiclo, dispararBloqueoCiclo } from '@/utils/bloqueoCiclo'
// Archivos css para las escuelas
import "./assets/css/escuela_css.css";

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(Embed);
// Vue.use(SoftUIDashboard);

// Alumnos/teachers: api-movil. En local usa VUE_APP_RUTA_API_INBI si existe
// (evita depender de api-movil en :3002). RH/Twilio sigue por VUE_APP_RUTA_API_RH.
if (store.state.ESCUELA == 1) {
  Vue.http.options.root = process.env.VUE_APP_RUTA_API_INBI || 'http://localhost:3002/'
} else {
  Vue.http.options.root = process.env.VUE_APP_RUTA_API_FAST || 'http://localhost:3002/'
}

Vue.http.interceptors.push((request, next) => {
  request.headers.set('X-App-Bloqueo', '1')
  try {
    const usuario = store.state.login && store.state.login.usuario
    const roll = usuario && usuario.roll
    const esAlumno = roll === 'ALUMNO' || roll === 1 || Number(roll) === 1
    if (usuario && usuario.id && esAlumno) {
      request.headers.set('X-Id-Usuario', String(usuario.id))
    }
  } catch (e) {}
  next((response) => {
    if (esBloqueoCiclo(response)) dispararBloqueoCiclo(response.body || response)
  })
})

new Vue({
    router,
    store,
    vuetify,
    render: function(h) { return h(App) }
}).$mount('#app')
